/**
 * routes 不受权限约束的路由
 * hideInMenu 控制不在菜单栏显示的路由，不受权限约束的子路由，如：增删改查等
 * 路由name设置与统一门户权限设置的字段对应（用于控制页面级别权限）
 */

export const routes = [
  {
    path: '/',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import('_v/style-center/login')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import('_v/style-center/login')
  },
  {
    path: '/link',
    name: 'link',
    meta: {
      title: '外部链接'
    },
    component: () => import('_v/style-center/link')
  },
  {
    path: '/external_links',
    name: 'external_links',
    meta: {
      title: '外部链接'
    },
    component: () => import('_v/external_links')
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '统一门户'
    },
    component: () => import('_v/home')
  },
  {
    path: '/home_old',
    name: 'home_old',
    meta: {
      title: '首页'
    },
    component: () => import('_v/home_old')
  },
  {
    path: '/autoLoginDD',
    name: 'autoLoginDD',
    meta: {
      title: '统一门户'
    },
    component: () => import('_v/autoLoginDD')
  },
  {
    path: '/autoLoginPC',
    name: 'autoLoginPC',
    meta: {
      title: '统一门户'
    },
    component: () => import('_v/autoLoginPC')
  },
  {
    path: '/phoneApp',
    name: 'phoneApp',
    meta: {
      title: '数智门户'
    },
    // redirect: '/autoLoginDD'
    component: () => import('_v/phoneApp')
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    meta: {
      hideInMenu: true,
      notCache: true,
      title: '重置密码'
    },
    component: () => import('_v/resetPassword')
  },
  {
    path: '/scanerror',
    name: 'error_scanerror',
    meta: {
      title: '错误页面',
      hideInMenu: true
    },
    component: () => import('_v/error-page/scanerror.vue')
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('_v/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('_v/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      // hideInMenu: true
    },
    component: () => import('_v/error-page/404.vue')
  }
]
